import { ShieldCheck, Clock, FileText, UserCheck, Layers, Activity } from 'lucide-react'
import { Badge, Card, CardContent } from '@/components/ui'
import { SectionHeading } from '@/components/common'
import { useAdminAuditLogsQuery } from '../../hooks/use-admin'

export function AuditLogsPage() {
  const { data: logs, isLoading } = useAdminAuditLogsQuery()
  const auditList = logs ?? []

  return (
    <div className="space-y-8">
      {/* Header */}
      <SectionHeading
        eyebrow="Platform Governance & Security"
        title="Admin Audit Trail & Activity Logs"
        description="Comprehensive audit trail recording all platform plan modifications, setting updates, application approvals, and plan assignments."
        align="left"
      />

      {/* Audit Log Table / List */}
      <Card className="border-border/80 bg-card/80 backdrop-blur-xl">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-2 border-b border-border/60 pb-3">
            <Activity className="size-5 text-primary" />
            <h3 className="font-display text-base font-bold text-foreground">
              Audit Event Log ({auditList.length})
            </h3>
          </div>

          {isLoading ? (
            <p className="text-xs text-muted-foreground">Loading audit log trail...</p>
          ) : auditList.length > 0 ? (
            <div className="space-y-3">
              {auditList.map((log: any) => (
                <div
                  key={log.id}
                  className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-xl border border-border/60 bg-background/50 p-4 text-xs"
                >
                  <div className="flex items-center gap-3">
                    <span className="flex size-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
                      <ShieldCheck className="size-4" />
                    </span>
                    <div>
                      <div className="flex items-center gap-2">
                        <Badge variant="outline" className="font-bold text-[10px] uppercase">
                          {log.action}
                        </Badge>
                        <span className="font-semibold text-foreground">{log.entityType}</span>
                        {log.entityId && (
                          <span className="text-[11px] font-mono text-muted-foreground">#{log.entityId}</span>
                        )}
                      </div>
                      {log.details && (
                        <p className="text-[11px] text-muted-foreground mt-1 font-mono truncate max-w-lg">
                          {JSON.stringify(log.details)}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="text-right shrink-0">
                    <p className="text-[11px] text-muted-foreground">
                      Admin ID: <span className="font-semibold text-foreground">#{log.userId ?? 'System'}</span>
                    </p>
                    <p className="text-[10px] text-muted-foreground flex items-center justify-end gap-1 mt-0.5">
                      <Clock className="size-3" /> {new Date(log.createdAt).toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="p-8 text-center text-xs text-muted-foreground space-y-2">
              <FileText className="mx-auto size-8 opacity-40" />
              <p>No audit log events recorded yet.</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
